export function isSondertageEventAdmin(currentUser, isAnAdmin, event) {
  if (isAnAdmin) return true;
  if (!currentUser || !event) return false;
  return event.admins?.includes(currentUser.id);
}
